import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import axios from "axios";
import LeftArrow from "../../../assets/leftArrow.svg";
import RightArrow from "../../../assets/rightArrow.svg";
import disableLeft from "../../../assets/disableLeft.svg";
import disableRight from "../../../assets/disableRight.svg";
import remove from "../../../assets/Remove.svg";
import RunOrSchedule from "../RunOrSchedule/RunOrSchedule";
import { API } from '../../../global';
import Loader from '../../ReUseable/Loader/Loader';
import CustomDropdown from '../../ReUseable/Dropdown/CustomDropdown';

const MappingTable = (props) => {
  const {
    sheet,
    clearStates,
    setSheet,
    selectedValues,
    setDataValidation,
    setReview,
    setReviewStepper,
    setAutoMappingStepper,
    setSkipDataValidation,
    setDeleteModalOpen,
    setDestinationStepper,
    setShowDestinationTables,
    setSelectedDestinationTables,  
  } = props;

  const [loading, setLoading] = useState(false);
  const [mappingScreen, setMappingScreen] = useState(true);
  const [showRunOrSchedule, setShowRunOrSchedule] = useState(false);
  const [unmappedTargetFields, setUnmappedTargetFields] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [editedApiResponse, setEditedApiResponse] = useState(null);
  const [sourceColumns, setSourceColumns] = useState([]);
  const [targetColumns, setTargetColumns] = useState({});
  const [tabs, setTabs] = useState([]);
  const [displayedTables, setDisplayedTables] = useState([]);

  const visibleTabCount = 7;
  const firstVisibleTabIndex = tabs.indexOf(displayedTables[0]);
  const lastVisibleTabIndex = firstVisibleTabIndex + visibleTabCount - 1;

  useEffect(() => {
    if (sheet) {
      setSheet(selectedValues[0]);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (sheet) {
      handleExcelSourceTargetMapping();
    } else {
      handleCsvSourceTargetMapping();
    }
    // eslint-disable-next-line
  }, [sheet]);

  useEffect(() => {
    if (editedApiResponse && activeTab) {
      const newSourceColumns = Object.keys(editedApiResponse.mapped_col[activeTab]);
      const newTargetColumns = editedApiResponse.mapped_col[activeTab];
      setSourceColumns(newSourceColumns);
      setTargetColumns(newTargetColumns);
    }
  }, [activeTab, editedApiResponse]);

  const handleExcelSourceTargetMapping = () => {
  };

  const handleCsvSourceTargetMapping = () => {
    const apiResponse = JSON.parse(localStorage.getItem(`MAPPING_API_RES`));
    if (apiResponse) {
      const { Act_col, mapped_col } = apiResponse;
      setEditedApiResponse(JSON.parse(JSON.stringify(apiResponse)));

      const mappedColKeys = Object.keys(mapped_col);
      setDisplayedTables(mappedColKeys.slice(0, 7));
      setTabs(mappedColKeys);
      setActiveTab(mappedColKeys[0]);
      setSourceColumns(Object.keys(mapped_col[mappedColKeys[0]]));
      setTargetColumns(mapped_col[mappedColKeys[0]]);

      const allMappedFields = new Set();
      Object.values(mapped_col).forEach((fields) => {
        Object.values(fields).forEach((field) => {
          allMappedFields.add(field);
        });
      });

      const unmappedTargetFields = Object.values(Act_col).flat().filter(field => !allMappedFields.has(field));

      setUnmappedTargetFields(unmappedTargetFields);
    }
  };

  const handleBackFromMappingReview = () => {
    setReview(false);
    setShowDestinationTables(true);
    setAutoMappingStepper(false);
    setReviewStepper(false);
    setSkipDataValidation(false);
    setDeleteModalOpen(false);
    setSelectedDestinationTables([]);
    const response = JSON.parse(localStorage.getItem('MAPPING_API_RES'));
    if (response) {
      localStorage.removeItem('MAPPING_API_RES');
    } else {
      setDataValidation(false);
    }
  };

  const handleOnDragTarget = (e, sourceField) => {
    const targetField = targetColumns[sourceField];
    e.dataTransfer.setData("targetField", JSON.stringify({ field: targetField, sourceField }));
  };

  const handleOnDropTarget = (e, sourceField) => {
    const unmappedField = e.dataTransfer.getData("unmappedField");

    if (unmappedField) {
      setTargetColumns((prevTargetColumns) => ({
        ...prevTargetColumns,
        [sourceField]: unmappedField,
      }));

      setUnmappedTargetFields((prevUnmappedTargetFields) =>
        prevUnmappedTargetFields.filter((field) => field !== unmappedField)
      );

      setEditedApiResponse((prevApiResponse) => ({
        ...prevApiResponse,
        mapped_col: {
          ...prevApiResponse.mapped_col,
          [activeTab]: {
            ...prevApiResponse.mapped_col[activeTab],
            [sourceField]: unmappedField,
          },
        },
      }));
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleOnDragUnmapped = (e, unmappedField) => {
    e.dataTransfer.setData("unmappedField", unmappedField);
  };

  const handleOnDropUnmapped = (e) => {
    const targetFieldData = JSON.parse(e.dataTransfer.getData("targetField"));

    if (targetFieldData) {
      const { field: targetField, sourceField } = targetFieldData;

      setUnmappedTargetFields((prevUnmappedTargetFields) => [
        ...prevUnmappedTargetFields,
        targetField,
      ]);

      setTargetColumns((prevTargetColumns) => ({
        ...prevTargetColumns,
        [sourceField]: "",
      }));

      setEditedApiResponse((prevApiResponse) => ({
        ...prevApiResponse,
        mapped_col: {
          ...prevApiResponse.mapped_col,
          [activeTab]: {
            ...prevApiResponse.mapped_col[activeTab],
            [sourceField]: "",
          },
        },
      }));
    }
  };

  const handleRemoveTargetField = (index, sourceField) => {
    setTargetColumns((prevTargetColumns) => ({
      ...prevTargetColumns,
      [sourceField]: ""
    }));

    setUnmappedTargetFields((prevUnmappedTargetFields) => {
      const mappedFields = Object.values(targetColumns).filter(Boolean);
      return [
        ...prevUnmappedTargetFields.filter(
          (field) => !mappedFields.includes(field)
        ),
        targetColumns[sourceField]
      ];
    });

    setEditedApiResponse((prevApiResponse) => ({
      ...prevApiResponse,
      mapped_col: {
        ...prevApiResponse.mapped_col,
        [activeTab]: {
          ...prevApiResponse.mapped_col[activeTab],
          [sourceField]: ""
        }
      }
    }));
  };

  const handleRunOrSchedule = async () => {
    setLoading(true);
    setMappingScreen(false);

    const fileDetails = {
      pipelineId: localStorage.getItem("pipelineId"),
      editedMappingData: editedApiResponse
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("auth_token")}`
      }
    };

    try {
      const res = await axios.post(`${API}/agent/save-edited-data-mapping`, JSON.stringify(fileDetails), config);
      if (res.data.success) {
        setShowRunOrSchedule(true);
        setLoading(false);
      } else {
        toast.error(res.data.error.msg);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during data mapping:", error);
      toast.error("An error occurred while saving the mapping data.");
    }
  };

  const handleTableSelection = (selectedTab) => {
    const index = tabs.indexOf(selectedTab);
    if (index !== -1) {
      setActiveTab(selectedTab);
    }
  };

  const handleForwardClick = () => {
    if (tabs.indexOf(activeTab) < lastVisibleTabIndex) {
      setActiveTab(prevTab => tabs[tabs.indexOf(prevTab) + 1]);
    } else if (tabs.indexOf(activeTab) === lastVisibleTabIndex) {
      setDisplayedTables(prevTabs => tabs.slice(firstVisibleTabIndex + 1, firstVisibleTabIndex + 1 + visibleTabCount));
      setActiveTab(prevTab => tabs[tabs.indexOf(prevTab) + 1]);
    }
  };

  const handleBackwardClick = () => {
    if (tabs.indexOf(activeTab) > firstVisibleTabIndex) {
      setActiveTab(prevTab => tabs[tabs.indexOf(prevTab) - 1]);
    } else if (tabs.indexOf(activeTab) === firstVisibleTabIndex) {
      setDisplayedTables(prevTabs => tabs.slice(firstVisibleTabIndex - 1, firstVisibleTabIndex - 1 + visibleTabCount));
      setActiveTab(prevTab => tabs[tabs.indexOf(prevTab) - 1]);
    }
  };

  return (
    <>
      {mappingScreen && (
        <div>
          <div className="mt-2 flex justify-between mb-5">
            <div className='flex gap-5 justify-center items-center'>
            </div>
            <div className='flex gap-2.5 justify-center items-center'>
              <button
                className="flex items-center gap-2 bg-[#BFBFBF] px-2 py-1 hover:bg-[#A5A5A5] text-white rounded-md text-sm"
                onClick={() => {
                  clearStates();
                }}
              >
                Cancel
              </button>
              <button
                className="flex items-center gap-2 bg-[#BFBFBF] px-[10px] py-[5px] hover:bg-[#A5A5A5] back-btn text-white rounded-md text-sm"
                onClick={() => {
                  handleBackFromMappingReview();
                }}
              >
                Back
              </button>
              <button
                className="flex items-center gap-2 bg-[#0078C5] px-2 py-1 hover:bg-[#00578F] text-white rounded-md text-sm"
                onClick={() => {
                  handleRunOrSchedule();
                }}
              >
                Continue
              </button>
            </div>
          </div>
          <>
            <div className="mt-2 text-sm flex justify-start">
              <div className="flex">
                {displayedTables.map((tab, i) => (
                  <div className='group relative' key={i}>
                    <div
                      className={`px-2 py-2.5 text-center rounded-t-lg w-28 border-x-[1px] border-t-[1px] border-[#C7C7C7] drop-item cursor-pointer font-medium ${tab === activeTab
                        ? "sheet_active"
                        : "bg-[#F9FAFB]"
                        }`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </div>
                    <span className='group-hover:visible invisible down-arrow text-sm'>
                      {tab}
                    </span>
                  </div>
                ))}
              </div>

              {tabs.length <= 7 ? (
                " "
              ) : (
                <div className="flex justify-end w-full gap-5 items-center">
                  <div className="flex gap-6">
                    <button onClick={handleBackwardClick} disabled={tabs.indexOf(activeTab) === tabs.indexOf(tabs[0])}>
                      <img src={tabs.indexOf(activeTab) === tabs.indexOf(tabs[0]) ? disableLeft : LeftArrow} alt="left" />
                    </button>

                    <button onClick={handleForwardClick} disabled={tabs.indexOf(activeTab) === tabs.length - 1}>
                      <img src={tabs.indexOf(activeTab) === tabs.length - 1 ? disableRight : RightArrow} alt="right" />
                    </button>
                  </div>

                  <CustomDropdown
                    options={tabs}
                    placeholder="Tables"
                    onSelect={handleTableSelection}
                    width="w-[150px]"
                    right={true}
                  />
                </div>
              )}
            </div>
          </>
          <div className='mb-[25px]'>
            <div className={`flex flex-col py-5 border border-[#C7C7C7] px-[100px] rounded-b-[10px] ${selectedValues?.length === 1 ? "" : "rounded-tr-[10px]"} overflow-y-auto`}>
              <div className='w-full flex items-center font-semibold mb-4'>
                <div className='w-[53%]'>SOURCE FIELDS</div>
                <div>DESTINATION FIELDS</div>
              </div>

              <div className='w-full flex flex-col gap-3 text-sm text-[#212529] font-semibold max-h-[34vh] overflow-y-auto'>
                {sourceColumns.map((source, index) => (
                  <div className='flex justify-center items-center me-3' key={index}>
                    <div className='w-[48%] h-[43px] rounded-[10px] shadow-[0_0_13px_2px_#efeded] py-[10px] border border-[#00000029] px-[20px] flex items-center'>{source}</div>
                    <div className='ms-2 me-3 flex items-center justify-center'>
                      {[...Array(8)].map((_, index) => (
                        <div
                          key={index}
                          className={`inline-block w-[3px] h-[3px] rounded-full bg-[#707070] ${index > 0 ? 'ms-1' : ''}`}
                        />
                      ))}
                    </div>
                    {targetColumns[source] !== "" ? (
                      <div
                        className={`w-[48%] h-[43px] rounded-[10px] flex justify-between items-center py-[10px] border border-[#00FF08] shadow-[0_0_13px_2px_#00FF081A]'                        
                            px-[20px]`}
                        draggable
                        onDragStart={(e) => handleOnDragTarget(e, source)}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleOnDropTarget(e, source)}
                      >
                        <div>{targetColumns[source]}</div>
                        <div className="flex gap-3 items-center justify-center">
                          <img
                            src={remove}
                            alt="remove"
                            onClick={() => handleRemoveTargetField(index, source)}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="w-[48%] rounded-[10px] h-[43px] shadow-[0_0_13px_2px_#FF09001A] py-[10px] border border-[#FF0900] px-[20px]"
                        onDrop={(e) => handleOnDropTarget(e, source)}
                        onDragOver={handleDragOver}
                      ></div>
                    )}
                  </div>
                ))}
              </div>

              <div className='font-semibold mt-[30px]'>
                UNMAPPED TARGET FIELDS
              </div>
              <div
                className='border h-[200px] border-[#83646429] shadow-[0_0_13px_2px_#efeded] mt-4 rounded-[10px] p-5 font-semibold text-[#212529] text-[14px] mb-[50px]'
                onDrop={handleOnDropUnmapped}
                onDragOver={handleDragOver}
              >
                {unmappedTargetFields.length > 0 ? (
                  <div className='flex items-center gap-5 flex-wrap'>
                    {unmappedTargetFields.map((field, i) => (
                      <div
                        className='h-[43px] border border-[#616161] rounded-[10px] flex items-center px-4 justify-center hover:bg-[#0083BF] hover:text-white hover:font-medium'
                        key={i}
                        draggable
                        onDragStart={(e) => handleOnDragUnmapped(e, field)}
                      >
                        {field}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className='text-[#616161] flex items-center justify-center h-full'>
                    No unmapped fields available.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {loading && (
        <Loader />
      )}

      {showRunOrSchedule && (
        <RunOrSchedule
          setShowRunOrSchedule={setShowRunOrSchedule}
          clearStates={clearStates}
          setDestinationStepper={setDestinationStepper}
        />
      )}
    </>
  );
};

export default MappingTable;